import API from "./API";

async function doPostTrialForUser(user_id, subscription_id) {
    return API.post(`/users/${user_id}/subscriptions/${subscription_id}/purchase`);
}

export {
    doPostTrialForUser,
}